<div [formGroup]="editForm" class="k-form" *ngIf="loaded">
    <button kendoButton [primary]="true" (click)="addNeed()" type="button" class="mb-2" *ngIf="!isDeleted">
        {{'ADD-NEED' | translate}}<i class="far fa-plus"></i>
    </button>
    <div formGroupName="needs" class="container-needs">
        <table class="table mb-0">
            <thead>
                <tr>
                    <th>
                        <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'SERVICE-CATEGORY' |
                            translate
                            }}
                            *
                        </label>
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr style="position:relative;top:10px" *ngIf=" editForm.controls.needs.controls.length === 0">
                    {{'NO-RULES-SUMMARY' | translate}}
                </tr>
                <tr
                    *ngFor="let serviceCategories of editForm.controls.needs.controls; let i=index; trackBy:needsTrackBy;">
                    <td style="width:100%" [formGroupName]="i">
                        <kendo-multiselect [data]="categoriesFiltered" formControlName="serviceCategories"
                            [textField]="'name'" [filterable]="true" [valueField]="'id'" [itemDisabled]="itemDisabled"
                            (filterChange)="filterCategories($event)" (close)="searchTerm=''" [autoClose]="true"
                            [virtual]="virtualCategory">
                            <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                </span>
                            </ng-template>
                        </kendo-multiselect>
                        <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.needs.controls[i].controls.serviceCategories.hasError('required') && 
                                editForm.controls.needs.controls[i].controls.serviceCategories.touched">
                            {{ 'REQUIRED-SERVICE-CATEGORY' | translate }} *
                        </div>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="editForm.controls.needs.controls[i].controls.importError.value">
                            {{ 'ASSESSMENT-DATA-PARTIALLY-LOADED-HINT' | translate }}
                        </div>
                        <div class="mt-2">
                            <app-formly-designer-rule-edit [ruleIndex]="i" [fields]="fields" [isDeleted]="isDeleted"
                                [expandWidth]="'107%'"
                                [showRules]="editForm.controls.needs.controls[i].controls.showRules.value"
                                [query]="editForm.controls.needs.controls[i].controls.query.value"
                                (showRulesChanged)="showRulesChanged($event)">
                            </app-formly-designer-rule-edit>
                        </div>
                    </td>
                    <td class="ng-untouched" *ngIf="!isDeleted">
                        <a title="{{ 'DELETE' | translate }}" (click)="removeNeed(i)">
                            <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>